import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./SupportAndMaintenancePage.scss";
import heroBanner from "../../assets/images/banner-support-maintenance.png";
import Copyright from "../../components/Copyright/Copyright";

const SupportAndMaintenancePage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={heroBanner} alt="Support and Maintenance" />
          </div>
        </div>
      </section>

      {/* Support and Maintenance Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>Comprehensive support and maintenance</h2>
              <p>
                Get the help you need when you need it with our dedicated support team.
                Our maintenance services ensure your system runs smoothly and efficiently,
                minimizing downtime and maximizing productivity.
              </p>

              <div className="feature-methods three-columns">
                <div className="feature-method">
                  <div className="method-content">
                    <h3>Multi-channel support</h3>
                    <p>
                      Get help through phone, email, chat, and ticket system.
                      Choose the communication method that works best for you.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Proactive maintenance</h3>
                    <p>
                      Regular system monitoring and maintenance to prevent issues before they occur.
                      Keep your system optimized and running at peak performance.
                    </p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Remote assistance</h3>
                    <p>
                      Quick problem resolution through secure remote access.
                      Our technicians can diagnose and fix issues without on-site visits.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>
              <div className="features-list">
                <div className="feature-item">
                  <h3>Expert technical support</h3>
                  <p>Access to certified professionals with deep knowledge of CashManager and financial systems.</p>
                </div>

                <div className="feature-item">
                  <h3>System health monitoring</h3>
                  <p>Continuous monitoring of your system performance with automated alerts and reporting.</p>
                </div>

                <div className="feature-item">
                  <h3>Regular updates and patches</h3>
                  <p>Keep your system secure and up-to-date with regular software updates and security patches.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Supported Services */}
      <section className="supported-section">
        <div className="container">
          <div className="section-header">
            <h2>Support and maintenance services</h2>
            <p>Comprehensive support covering all aspects of your system</p>
          </div>

          <div className="items-grid">
            <div className="item">
              <h3>Technical support</h3>
              <ul>
                <li>System troubleshooting and diagnostics</li>
                <li>Configuration and setup assistance</li>
                <li>Integration support and guidance</li>
                <li>Performance optimization</li>
                <li>Data backup and recovery</li>
              </ul>
            </div>

            <div className="item">
              <h3>Maintenance services</h3>
              <ul>
                <li>Regular system health checks</li>
                <li>Database optimization and cleanup</li>
                <li>Security updates and patches</li>
                <li>Performance monitoring and tuning</li>
                <li>Disaster recovery planning</li>
              </ul>
            </div>

            <div className="item">
              <h3>Training and consultation</h3>
              <ul>
                <li>User training and onboarding</li>
                <li>Best practices consultation</li>
                <li>Workflow optimization</li>
                <li>Custom feature development</li>
              </ul>
            </div>

            <div className="item">
              <h3>Emergency support</h3>
              <ul>
                <li>Critical issue resolution</li>
                <li>System recovery services</li>
                <li>Data restoration assistance</li>
                <li>Emergency patch deployment</li>
                <li>24/7 on-call support</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready for reliable support?</h2>
            <p>
              Get the peace of mind that comes with professional support and maintenance.
              Contact us today to discuss your support needs.
            </p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default SupportAndMaintenancePage;
